import { enumUnit, Unit } from '@rematter/frontend-lib-api-client';

import { Maybe } from './typeUtils';

export const shortenUnit = (unit: Maybe<Unit>) => {
  switch (unit) {
    case enumUnit.Pounds:
      return 'lb';
    case enumUnit.Ounces:
      return 'oz';
    case enumUnit.Kilograms:
      return 'kg';
    case enumUnit.Grams:
      return 'g';
    case enumUnit.GrossTons:
      return 'GT';
    case enumUnit.NetTons:
      return 'NT';
    case enumUnit.LongTons:
      return 'LT';
    case enumUnit.LongHundredweight:
      return 'LCWT';
    case enumUnit.ShortHundredweight:
      return 'SCWT';
    case enumUnit.MetricTons:
      return 'MT';
    case enumUnit.ShortTons:
      return 'ST';
    case enumUnit.Each:
      return 'ea';
    case enumUnit.Meter:
      return 'm';
    case enumUnit.Yard:
      return 'yd';
    default:
      return '';
  }
};
